import {AfterViewInit, Component, Directive, Input, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation} from '@angular/core';
import {BsModalRef, BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {ToastrService} from 'ngx-toastr';
import {language} from '../../../../language/vn';
import {CommandUtil} from '../../../../global/commandutil';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {Sessioncommand} from '../../../../global/sessioncommand';
import {Thu} from '../../../../models/email/thu';
import {ThuFile} from '../../../../models/email/thufile';
import {ThuService} from '../../../../service/email/service-thu';
import {ThuFileService} from '../../../../service/email/service-thufile';
import {TraLoiThuComponent} from '../traloi/traloi.component';
import {CTThuNhanComponent} from '../chuyentrinh/thunhan.component';
import {GVThuNhanComponent} from '../giaoviec/thunhan.component';
import {GuiTiepThuComponent} from '../guitiep/guitiep.component';
import {StaffsService} from '../../../../service/staff/service-staffs';
import {ChenHoSoThuComponent} from '../chenhoso/chenhoso.component';
import {ChenHoSoThuGuiComponent} from '../chenhoso/thugui.component';
import {ThuTempService} from '../../../../service/email/service-thutemp';
import {DomSanitizer} from '@angular/platform-browser';
@Component({
  selector: 'email-detail-item',
  templateUrl: './detail.component.html',
  encapsulation: ViewEncapsulation.None

})
export class DetailThuComponent implements OnInit, AfterViewInit {

  @Input() emailId: number = 0;
  public id: number = -1;
  public language = language;
  public thuItem: Thu = new Thu();
  public thuFiles: ThuFile[] = [];
  public nguoiNhan: string = '';
  public thuNhoms: Thu[]= [];

  constructor(
    public thuService: ThuService,
    public thuTempService: ThuTempService,
    public toastr: ToastrService,
    public formBuilder: FormBuilder,
    public bsModalService: BsModalService,
    public datepipe: DatePipe,
    public commandUtil: CommandUtil,
    public thuFileService: ThuFileService,
    public staffsService: StaffsService,
    public sanitizer: DomSanitizer

  ) {
  }
  ngAfterViewInit() {

  }

  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

  }
  ngOnInit(): void {

    this.edit(this.emailId);
  }
  public chuyenGiaoViec(id: string) {
    const modalEdit = this.bsModalService.show(GVThuNhanComponent, {class: 'modal-xl'});
    (<GVThuNhanComponent>modalEdit.content).edit(
      Number(id!=''?id:'0')
    );
    (<GVThuNhanComponent>modalEdit.content).onClose.subscribe(result => {

    });

  }
  public traLoi(id: number, show: boolean) {
    const modalEdit = this.bsModalService.show(TraLoiThuComponent, {class: 'modal-xl'});
    (<TraLoiThuComponent>modalEdit.content).edit(
      id, show
    );
    (<TraLoiThuComponent>modalEdit.content).onClose.subscribe(result => {
      if(result === true)
        Sessioncommand.emailStatus = 0;
    });

  }
  public chuyenTrinh(id: string) {
    const modalEdit = this.bsModalService.show(CTThuNhanComponent, {class: 'modal-xl'});
    (<CTThuNhanComponent>modalEdit.content).edit(
      Number(id!=''? id: '0')
    );
    (<CTThuNhanComponent>modalEdit.content).onClose.subscribe(result => {

    });

  }
  public guiTiep(id: number) {
    const modalEdit = this.bsModalService.show(GuiTiepThuComponent, {class: 'modal-xl'});
    (<GuiTiepThuComponent>modalEdit.content).edit(
      id
    );
    (<GuiTiepThuComponent>modalEdit.content).onClose.subscribe(result => {

    });

  }

  public chenHoSo(id: number) {
    const modalEdit = this.bsModalService.show(ChenHoSoThuComponent, {class: 'modal-xl'});
    (<ChenHoSoThuComponent>modalEdit.content).edit(
      id
    );
    (<ChenHoSoThuGuiComponent>modalEdit.content).onClose.subscribe(result => {
    });
  }
  public edit(id: number) {
    this.id = id;
    this.thuService.getByReadId(id).subscribe(data => {
      this.thuItem = data;
      this.thuFileService.findAllByThuId(data.nhomThu).subscribe(dt => this.thuFiles = dt);
      this.thuTempService.getById(data.nhomThu).subscribe(
        x => {
          this.nguoiNhan =x.nguoinhanTen;
        });
      this.thuService.getAllByNhomThu(data.id, Sessioncommand.staffId).subscribe( nt => this.thuNhoms = nt);
    });
  }
}

